export default "__VITE_ASSET__Crk8aP3___"